import Vue from "vue";
import { Component, Emit } from "vue-property-decorator";
import {
    UserInfos,
    NotificationExpedition,
    NotificationAskExpedition,
    ExpeditionInit,
} from "@/components";
import { IExpeditionNotification, NotificationType, IExpeditionInit } from "@/models";
import vSelect from "vue-select";
import DatePicker from "vue2-datepicker";
import { Moment } from "moment";

@Component({
    name: "sidebarExpedition",
    components: {
        "userinfos": UserInfos,
        "notification-expedition": NotificationExpedition,
        "notification-askExpedition": NotificationAskExpedition,
        "expedition-init": ExpeditionInit,
        "v-select": vSelect,
        "datepicker": DatePicker,
    },
})

export default class SidebarExpedition extends Vue {
    public collapsed: boolean;

    public askAppointmentDock: number = 1;
    public askAppointmentExpectedArrival: Moment = null;
    public showModal: boolean = false;
    public readonly addExpeditionModalFromNotification: string = "addExpeditionModalFromNotification";

    constructor() {
        super();

        this.collapsed = true;
    }

    public get selectedNotification(): IExpeditionNotification {
        return this.$store.getters["expeditions/getSelectedNotification"]();
    }

    public get notifications(): IExpeditionNotification[] {
        return this.$store.getters["expeditions/notifications"]();
    }

    public toggleCollapsed(): void {
        this.collapsed = this.collapsed ? false : true;
    }

    public showExpeditionInit(): void {
        if (this.selectedNotification !== null && this.selectedNotification.type === NotificationType.AskAppointment) {
            this.showModal = true;
        }
    }

    public closeModal(): void {
        this.showModal = false;
        this.$store.commit("expeditions/SET_SELECTED_NOTIFICATION", null);
    }
}
